import { Col, Row, Badge, Card, Typography, Tag as AntTag } from "antd";
import PropTypes from "prop-types";
import React from "react";
// import Status from "../status";
// import TransactionsLevel from "./transactionsLevel";
// import Warning from "./warning";
import Timer from "controllers/timer";
import TimerCard from "components/cards/timer";
import Tag from "components/cards/tag";

export default function ChatCard({
  number,
  unreadMessagesCount,
  name,
  lastMessage,
  active,
  warning,
  startedAt,
  beDestroyedAt,
  isTyping,
  isTrial,
  isOnline,
  paidMinutes,
  transactionsLevel,
  onClick,
  tag,
}) {
  return (
    <Card
      onClick={onClick}
      hoverable
      style={{ backgroundColor: active ? "lightblue" : "" }}
    >
      {isTrial && <Typography.Text type="warning">TRIALING</Typography.Text>}
      {/* {transactionsLevel && <TransactionsLevel level={transactionsLevel} />} */}
      {/* {warning && <Warning text={warning} />} */}
      <Row gutter={24} justify="space-between">
        <Col span={1}>
          <Typography.Text type="warning" style={{ textAlign: "center" }}>
            {number}
          </Typography.Text>
        </Col>
        {tag && <Tag tag={tag} />}
        <Col span={10}>
          <Typography.Text type="primary" style={{ textAlign: "center" }}>
            {name}
          </Typography.Text>
        </Col>
        <Col span={7}>
          <TimerCard
            warning={!!beDestroyedAt}
            date={beDestroyedAt || startedAt}
          />
        </Col>
        <Col span={2}>
          <AntTag color={isOnline ? "green" : "red"}>
            {isOnline ? "online" : "offline"}
          </AntTag>
        </Col>
        <Col span={2}>
          <Badge count={unreadMessagesCount} />
        </Col>
      </Row>
      {paidMinutes && (
        <p>
          <Typography.Text type="primary">
            {`Paid for minutes: ${paidMinutes}`}
          </Typography.Text>
        </p>
      )}
      <p>
        <Typography.Text type="secondary">
          {isTyping ? "User is typing..." : lastMessage.text}
        </Typography.Text>
      </p>
    </Card>
  );
}

ChatCard.propTypes = {
  number: PropTypes.number.isRequired,
  unreadMessagesCount: PropTypes.number,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  isTyping: PropTypes.bool,
  isOnline: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  startedAt: PropTypes.string,
  isTrial: PropTypes.bool,
  transactionsLevel: PropTypes.string,
};

ChatCard.defaultProps = {
  startedAt: null,
  isTrial: false,
  isTyping: false,
  active: false,
  unreadMessagesCount: 0,
  transactionsLevel: null,
};
